module.exports = __webpack_public_path__ + "static/media/strategie_marketing_LTM.205637c1.doc";